import * as React from 'react'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Box, CircularProgress } from '@mui/material'
import {
  Callback,
  WithDataCy
} from '@/layouts/core/types/core'

export type ModalButtonProps = {
  text: string
  onClick?: Callback
  disabled?: boolean
}

export type ModalDialogProps = {
  cancelButton?: ModalButtonProps
  children: React.ReactNode
  isLoading?: boolean
  renderButton: (cb: Callback) => React.ReactNode
  size: DialogProps['maxWidth']
  submitButton?: ModalButtonProps
  title?: string | React.ReactNode
} & WithDataCy

const ChronoModal = (props: ModalDialogProps) => {
  const {
    cancelButton,
    children,
    isLoading,
    renderButton,
    size,
    submitButton,
    title,
  } = props
  const [open, setOpen] = useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const makeOnClose = (cb: Callback) => {
    return (e) => {
      e.preventDefault()
      handleClose()
      cb && cb(e)
      return false
    }
  }

  return (
    <>
      {renderButton(handleClickOpen)}

      <Dialog
        data-cy={props['data-cy']}
        fullWidth={true}
        maxWidth={size}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">

        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'start'}>
          {title &&
            <DialogTitle id="alert-dialog-title" style={{ maxWidth: '60%' }}>
              {title}
            </DialogTitle>
          }
          <CloseIcon onClick={handleClose} style={{ fontSize: 32, cursor: 'pointer', margin: 10 }} />
        </Box>


        <DialogContent>
          {children}
        </DialogContent>

        <DialogActions>
          {cancelButton &&
            <Button
              disabled={cancelButton.disabled}
              onClick={makeOnClose(cancelButton.onClick)}>
              {cancelButton.text}
            </Button>
          }
          {submitButton &&
            <Button
              disabled={submitButton.disabled || isLoading}
              onClick={submitButton.onClick}
              autoFocus
              variant='contained'
              sx={{ padding: isLoading ? '6px 38px' : '6px 16px' }}
            >
              {isLoading
                ? <CircularProgress size={25} />
                : submitButton.text
              }
            </Button>
          }
        </DialogActions>

      </Dialog>
    </>
  )
}

export default ChronoModal
